// Service-area (city) pages: /service-areas/:slug
// Each city gets its own intro so pages are not duplicate content.
export const SERVICE_AREAS = [
    {
        slug: 'parkland',
        city: 'Parkland',
        county: 'Broward County',
        image: '/assets/images/3.webp',
        intro: 'Just south of Boca Raton, Parkland homeowners count on 561-FIX-HOME for remodels, renovations and general contracting with the same 5-star care.',
    },
    {
        slug: 'coconut-creek',
        city: 'Coconut Creek',
        county: 'Broward County',
        image: '/assets/images/4.webp',
        intro: 'Coconut Creek homeowners call on 561-FIX-HOME for kitchen and bath remodels, home repairs and general contracting, with honest pricing and work done right the first time.',
    },
    {
        slug: 'coral-springs',
        city: 'Coral Springs',
        county: 'Broward County',
        image: '/assets/images/2.webp',
        intro: 'From family homes to townhouses, we help Coral Springs homeowners with remodels, repairs and upgrades, handled by a licensed and insured local team.',
    },
    {
        slug: 'pompano-beach',
        city: 'Pompano Beach',
        county: 'Broward County',
        image: '/assets/images/1.webp',
        intro: 'Whether you live near the beach or further inland, our team brings dependable remodeling and renovation work to Pompano Beach homes and condos.',
    },
    {
        slug: 'deerfield-beach',
        city: 'Deerfield Beach',
        county: 'Broward County',
        image: '/assets/images/5.webp',
        intro: 'Right on Boca Raton’s southern border, Deerfield Beach is in our backyard. We handle everything from quick repairs to full kitchen and bath remodels.',
    },
    {
        slug: 'hillsboro-mile',
        city: 'Hillsboro Mile',
        county: 'Broward County',
        image: '/assets/images/3.webp',
        intro: 'We serve the oceanfront homes of Hillsboro Mile with careful, detail-oriented work and clear communication from the first quote to the final cleanup.',
    },
    {
        slug: 'lighthouse-point',
        city: 'Lighthouse Point',
        county: 'Broward County',
        image: '/assets/images/4.webp',
        intro: 'Lighthouse Point homeowners trust us for remodels, repairs and upgrades, finished on schedule and built to stand up to the South Florida climate.',
    },
    {
        slug: 'boca-raton',
        city: 'Boca Raton',
        county: 'Palm Beach County',
        image: '/assets/images/2.webp',
        intro: 'Boca Raton is home base for 561-FIX-HOME. From condos near the beach to single-family homes out west, we help Boca homeowners with remodels, repairs and everything in between.',
    },
    {
        slug: 'delray-beach',
        city: 'Delray Beach',
        county: 'Palm Beach County',
        image: '/assets/images/1.webp',
        intro: 'Whether you own a historic home near Atlantic Avenue or a newer build in west Delray, our team delivers quality remodeling and renovation work that fits your home’s character.',
    },
    {
        slug: 'highland-beach',
        city: 'Highland Beach',
        county: 'Palm Beach County',
        image: '/assets/images/5.webp',
        intro: 'Condo and oceanfront homeowners in Highland Beach count on us for remodels and repairs that are coordinated with building management and done right the first time.',
    },
    {
        slug: 'boynton-beach',
        city: 'Boynton Beach',
        county: 'Palm Beach County',
        image: '/assets/images/3.webp',
        intro: 'Boynton Beach homeowners count on us for kitchen and bath remodels, interior updates and exterior projects, all completed on schedule and cleaned up when we leave.',
    },
    {
        slug: 'lake-worth-beach',
        city: 'Lake Worth Beach',
        county: 'Palm Beach County',
        image: '/assets/images/4.webp',
        intro: 'From updating older cottages to modernizing kitchens and baths, we help Lake Worth Beach homeowners improve comfort and value with licensed, insured work.',
    },
    {
        slug: 'greenacres',
        city: 'Greenacres',
        county: 'Palm Beach County',
        image: '/assets/images/2.webp',
        intro: 'Greenacres homeowners rely on 561-FIX-HOME for kitchen and bath remodels, interior updates and exterior projects, quoted honestly and finished on time.',
    },
];

export const getServiceArea = (slug) => SERVICE_AREAS.find((a) => a.slug === slug);

// Cities grouped by county, home county first. Used wherever the full list is shown.
export const AREA_GROUPS = ['Palm Beach County', 'Broward County'].map((county) => ({
    county,
    areas: SERVICE_AREAS.filter((a) => a.county === county),
}));
